import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type UpdateAeExportSettingsMutationVariables = Types.Exact<{
  input: Types.AeExportSettingsInput;
}>;


export type UpdateAeExportSettingsMutation = { __typename?: 'Mutation', updateAeExportSettings?: { __typename?: 'AeExportSettings', assetFolderId?: string | null, assetFolderName?: string | null, exportMarkersAsCommentsEnabled?: boolean | null, localCopyEnabled?: boolean | null, localFolderPath?: string | null, outputModuleTemplate?: string | null, range?: Types.AeExportRange | null, renderSettingTemplate?: string | null } | null };


export const UpdateAeExportSettings = /*#__PURE__*/ gql`
    mutation UpdateAeExportSettings($input: AeExportSettingsInput!) {
  updateAeExportSettings(input: $input) {
    assetFolderId
    assetFolderName
    exportMarkersAsCommentsEnabled
    localCopyEnabled
    localFolderPath
    outputModuleTemplate
    range
    renderSettingTemplate
  }
}
    ` as unknown as DocumentNode<UpdateAeExportSettingsMutation, UpdateAeExportSettingsMutationVariables>;

          

          export const useUpdateAeExportSettingsMutation = (options?:MutationHookOptions<UpdateAeExportSettingsMutation, UpdateAeExportSettingsMutationVariables>) => useMutation(UpdateAeExportSettings, options);
          

          export type UpdateAeExportSettingsMutationOptions = MutationHookOptions<UpdateAeExportSettingsMutation, UpdateAeExportSettingsMutationVariables>;

          

          export type UpdateAeExportSettingsMutationResult = ReturnType<typeof useUpdateAeExportSettingsMutation>[1];

          
